import {Outlet, useMatches, useSearchParams} from 'react-router'
import {ModelStatusProvider} from '@core/hooks/useModelStatusProvider'

import styles from '@product/narcis/styles/_layout.module.scss'
import type {FooterHandle} from '@product/narcis/path'
import {Footer} from '@product/narcis/components/Footer/Footer'

export default function Layout() {
    const [search] = useSearchParams()
    const footerless = useMatches().some((match) => (match.handle as FooterHandle | undefined)?.footerless?.(search))
    return (
        <ModelStatusProvider url="/api/model-status">
            <div className={styles.Layout}>
                <a href="#main-content" className={styles.skipLink}>Skip to content</a>
                <main id="main-content">
                    <Outlet/>
                </main>
                {!footerless && <Footer/>}
            </div>
        </ModelStatusProvider>
    )
}
